import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgRedux, select } from '@angular-redux/store';
import { ArgosState } from '../../../core/argos-state';
import { ADD_FREE_ACCESSORY } from '../../../core/actions';
import { AccessoryLocal } from '../../../shared/model/accessory-local';
import { AccessoryAmount } from '../../../shared/model/accessory-amount';
import { AccessoryLocalService } from '../../../shared/service/accessory-local.service';
import { AccessoryAmountMovement } from '../../../shared/model/accessory-amount-movement';
import { AccessoryStatusService } from '../../service/accessory-status.service';
import { AccessoryStatus } from '../../../shared/model/accessory-status';
import { ToastService } from '../../../shared/service/toast.service';
import { AuthenticationService } from '../../../shared/service/authentication.service';
import { Router } from '@angular/router';
import { UserRoles } from '../../../attending/constants/user-roles';

declare var Materialize: any;

@Component({
  selector: 'tx-accessory',
  templateUrl: './accessory.component.html',
  styleUrls: ['./accessory.component.css']
})
export class AccessoryComponent implements OnInit {
  @Output() txOnMoveAccessory: EventEmitter<any>;
  @Output() txOnCancelMove: EventEmitter<any>;
  @Input() selectedLocal: AccessoryLocal;
  @Input() accessories: Map<string, Array<AccessoryAmount>> = new Map();
  @Input() amountMovement: Array<AccessoryAmountMovement> = new Array();
  @Input() fixedSize = true;
  @select('freeAccessoriesTotal') freeAccessoriesTotal$;
  @select('freeAccessories') freeAccessories$;
  opened = '';
  isMovingAccessories = false;
  localsToMove: Array<AccessoryLocal>;
  accessoryStatus: Array<AccessoryStatus>;
  authenticatedUser: any;

  constructor(private ngRedux: NgRedux<ArgosState>,
              private _accessoryLocalService: AccessoryLocalService,
              private _accessoryStatusService: AccessoryStatusService,
              private _toastService: ToastService,
              private _authService: AuthenticationService,
              private _router: Router) {
    this.txOnMoveAccessory = new EventEmitter();
    this.txOnCancelMove = new EventEmitter();
    this.setUpObservers();
    this.findAccessoryStatus();
    this.setEmptyEntities();
  }

  ngOnInit() {
    if (this.fixedSize === undefined) {
      this.fixedSize = true;
    }
  }

  private setEmptyEntities() {
    this.authenticatedUser = this._authService.getUserFromLocalStorage();
  }

  save() {
    if (this.canSave()) {
      this.isMovingAccessories = false;
      this.txOnMoveAccessory.emit(this.amountMovement);
    } else {
      this.showMessage('Mova todos os acessórios escolhidos corretamente.');
    }
  }

  cancel() {
    this.stopMovingAccessories();
    this.txOnCancelMove.emit();
  }

  addFreeAccessory(amount) {
    if (amount.quantity > 0) {
      this.ngRedux.dispatch({ type: ADD_FREE_ACCESSORY, body: amount });
    }
  }

  addToAmountMovement(event, amount, freeAccessory) {
    const assignedTotal = this.countTotalAssigned(freeAccessory);
    const stillFree = freeAccessory.quantity - assignedTotal;
    if (stillFree >= 0) {
      return event.target.valueAsNumber;
    } else {
      event.target.valueAsNumber -= 1;
      return event.target.valueAsNumber;
    }
  }

  thereIsFreeAccessory(accessory) {
    const assignedTotal = this.countTotalAssigned(accessory);
    const stillFree = accessory.quantity - assignedTotal;
    return stillFree > 0;
  }

  addAccessoryMovement(freeAccessory) {
    if (this.thereIsFreeAccessory(freeAccessory)) {
      const newAmount = new AccessoryAmountMovement();
      newAmount.accessoryId = freeAccessory.accessoryId;
      newAmount.quantity = 1;
      this.amountMovement.push(newAmount);
    }
  }

  findLocalsToMove(name: string) {
    this._accessoryLocalService
      .findByNameIgnoreLocal(name, 0, 30, this.selectedLocal.id, this.selectedLocal.accessoryLocalType);
  }

  getAccessoriesKeys() {
    if (this.accessories) {
      return Object.keys(this.accessories);
    }
    return [];
  }

  getAmountQuantity(key) {
    let total = 0;
    this.accessories[key].forEach(amount => {
      total += amount.quantity;
    });
    return total;
  }

  toggleOpenedAccessory(accessoryType) {
    if (this.opened === accessoryType) {
      this.opened = '';
    } else {
      this.opened = accessoryType;
    }
  }

  moveAccessories() {
    if (this.ngRedux.getState().freeAccessoriesTotal > 0) {
      this.isMovingAccessories = true;
      this.opened = '';
    }
  }

  stopMovingAccessories() {
    this.isMovingAccessories = false;
    this.opened = '';
  }

  getMaxAccessories(totalQuantity, accessoryId) {
    let assignedTotal = 0;
    for (const amount of this.amountMovement) {
      if (amount.accessoryId === accessoryId) {
        assignedTotal += amount.quantity;
      }
    }
    return totalQuantity - assignedTotal;
  }

  canCreateAccessory() {
    if (this.authenticatedUser.role === UserRoles.ESTOQUE || this.authenticatedUser.role === UserRoles.ADMIN) {
      return true;
    }
  }

  newAccessory() {
    this._router.navigate(['accessories/new']);
  }

  private canSave() {
    const totalAvailable = this.ngRedux.getState().freeAccessoriesTotal;
    const totalAssigned = this.setAmountAttributes();
    return totalAssigned === totalAvailable;
  }

  private setAmountAttributes() {
    let totalAssigned = 0;
    for (const amount of this.amountMovement) {
      if (amount.accessoryStatus) {
        amount.accessoryStatusId = amount.accessoryStatus.id;
      } else {
        return 0;
      }
      amount.localId = amount.local.id;
      amount.localType = amount.local.accessoryLocalType;
      totalAssigned += amount.quantity;
    }
    return totalAssigned;
  }

  private findAccessoryStatus() {
    this._accessoryStatusService.findAll()
      .subscribe(
        status => this.accessoryStatus = status,
        error => this.showMessage(error)
      );
  }

  private countTotalAssigned(freeAccessory) {
    let assignedTotal = 0;
    for (const currentAmount of this.amountMovement) {
      if (currentAmount.accessoryId === freeAccessory.accessoryId) {
        assignedTotal += currentAmount.quantity;
      }
    }
    return assignedTotal;
  }

  private setUpObservers() {
    this._accessoryLocalService.findLocalToMove$
      .subscribe(localsToMove => this.localsToMove = localsToMove);
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/accessory/component/accessory/accessory.component.ts